import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IGame, IGameAttendancesVotes } from "@grassrootly/api";

export interface GameState {
  games: { [key: number]: IGame };
  latestGameId: number | null;
  gameVotes: { [key: number]: IGameAttendancesVotes[] };
}

const initialState: GameState = {
  games: {},
  latestGameId: null,
  gameVotes: {},
};

const gamesSlice = initReducer({
  name: "games",
  initialState,
  reducers: {
    setGames: (state: GameState, action: PayloadAction<IGame[]>) => {
      const mapedGames: any = {};
      action.payload.forEach((g) => {
        mapedGames[g.id] = g;
      });
      state.games = { ...state.games, ...mapedGames };
    },
    setGame: (state: GameState, action: PayloadAction<IGame>) => {
      state.games = { ...state.games, [action.payload.id]: action.payload };
    },
    setLatestGame: (state: GameState, action: PayloadAction<number>) => {
      state.latestGameId = action.payload;
    },
    setGameVotes: (state: GameState, action: PayloadAction<{ gameId: number; votes: IGameAttendancesVotes[] }>) => {
      state.gameVotes = { ...state.gameVotes, [action.payload.gameId]: action.payload.votes };
    },
    cleanState: () => {
      return initialState;
    }
  },
});

const persistConfig: PersistConfig<GameState> = {
  key: "games",
  whitelist: ["latestGameId"],
  storage: AsyncStorage,
};

export const gameActions = gamesSlice.actions;

export default createPersistReducer(persistConfig, gamesSlice.reducer);
